import { useDrag, useDragLayer } from "react-dnd"
import { ID } from "@nova/constants"
import { WorkspaceEntityType } from "../types"

type UseWorkspaceProjectDragAndDropProps = {
    id: ID
    isEditor: boolean
    isRenaming: boolean
}

export const useWorkspaceProjectDragAndDrop = ({
    id,
    isEditor,
    isRenaming,
}: UseWorkspaceProjectDragAndDropProps) => {
    const [{}, dragRef] = useDrag(
        () => ({
            type: WorkspaceEntityType.Project,
            item: {
                id,
                type: WorkspaceEntityType.Project,
            },
            collect: () => ({
                //isDragging: !!monitor.isDragging(),
            }),
            canDrag: !isRenaming && isEditor,
        }),
        [id, isRenaming, isEditor]
    )

    const anythingIsDragging = useDragLayer((monitor) => {
        const type = monitor.getItemType()
        const isAcceptableType =
            type === WorkspaceEntityType.Folder || type === WorkspaceEntityType.Project
        return monitor.isDragging() && isAcceptableType
    })

    return {
        dragRef,
        anythingIsDragging,
    }
}
